export default __webpack_public_path__ + "static/media/iconClose.71c67d5c.svg";